var _rect, _ellipse, _ellipse2, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroup73(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 84,
    height: 89,
    viewBox: "0 0 84 89",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 32.575,
    width: 50.3433,
    height: 55.4584,
    rx: 8,
    fill: "url(#paint0_linear_179_129)"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 51.5522,
    cy: 32.4402,
    rx: 32.4402,
    ry: 32.4402,
    fill: "url(#paint1_linear_179_129)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_179_129",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 19,
    y: 0,
    width: 66,
    height: 65
  }, _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 51.5605,
    cy: 32.4402,
    rx: 32.4402,
    ry: 32.4402,
    fill: "url(#paint2_linear_179_129)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_179_129)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -5.38086,
    y: 32.5745,
    width: 57.0732,
    height: 55.4579,
    rx: 8,
    fill: "url(#paint3_linear_179_129)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_179_129",
    x1: 40.8445,
    y1: 88.0333,
    x2: 6.50693,
    y2: 47.486,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3646DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#528EFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_179_129",
    x1: 83.9924,
    y1: 32.4402,
    x2: 19.1121,
    y2: 32.4402,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7714E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AF8BFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_179_129",
    x1: 84.0007,
    y1: 32.4402,
    x2: 19.1204,
    y2: 32.4402,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7714E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AF8BFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_179_129",
    x1: 23.1557,
    y1: 32.5745,
    x2: 23.1557,
    y2: 88.0324,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#999999"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup73);
export default __webpack_public_path__ + "static/media/Group 73.dc38bdc46f0750ff735e9f660bc81440.svg";
export { ForwardRef as ReactComponent };